import React from 'react'
import { ActionIcon } from '@mantine/core'

function Icon({ width, height, color = 'currentColor' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      class="design-iconfont"
      width={width}
      height={height}
    >
      <path
        d="M4.99988174,3 L4.99987984,4 L13.9998808,4.00002491 L13.9998808,3 L4.99988174,3 Z M2.00048828,3 L2.00048828,4 L3.49988079,4 L3.49988079,3 L2.00048828,3 Z M13.9998808,7.50008583 L13.9998808,8.50008583 L4.99987984,8.50006104 L4.99988174,7.50006104 L13.9998808,7.50008583 Z M3.49988079,7.50006104 L3.49988079,8.50006104 L2.00048828,8.50006104 L2.00048828,7.50006104 L3.49988079,7.50006104 Z M13.9998808,12.0000248 L13.9998808,13.0000248 L4.99987984,13.0000248 L4.99988174,12 L13.9998808,12.0000248 Z M3.49988079,12 L3.49988079,13.0000248 L2.00048828,13.0000248 L2.00048828,12 L3.49988079,12 Z"
        fill={color}
        fill-opacity=".9"
        fill-rule="evenodd"
      />
    </svg>
  )
}
const FontBulletListIcon = (props) => {
  const {
    fill = 'blue',
    variant = 'transparent',
    size = 'lg',
    radius = 'lg',
    width = 20,
    height = 20,
    loading = false,
    disabled = false,
  } = props
  return (
    <ActionIcon
      color={fill}
      variant={variant}
      size={size}
      radius={radius}
      loading={loading}
      disabled={disabled}
    >
      <Icon width={width} height={height} />
    </ActionIcon>
  )
}

export default FontBulletListIcon
